export enum Role {
    Empty,
    Admin,
    CompanyOwner,
    CompanyAdmin,
    CompanyUser
}
